import { html as o, when as t } from "@microsoft/fast-element";
const e = o`
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.7274 21.9997H18.2728C19.7791 21.9997 21 20.7788 21 19.2724V16.5452"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.36367 14C7.36367 12.8954 6.46824 12 5.36367 12H2.81824V16.5454C2.81824 17.55 3.63187 18.3636 4.63641 18.3636H5.36367C6.46824 18.3636 7.36367 17.4682 7.36367 16.3636V14Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21 12H18.4545C17.35 12 16.4545 12.8954 16.4545 14V16.3636C16.4545 17.4682 17.35 18.3636 18.4545 18.3636H19.1818C20.1863 18.3636 21 17.55 21 16.5454V12Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21 11.9999V11.0909C21 6.06998 16.93 2 11.9091 2C6.88821 2 2.81824 6.06998 2.81824 11.0909V11.9999"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle
      cx="0.75"
      cy="0.75"
      r="0.75"
      transform="matrix(1 0 0 -1 13 22.75)"
      stroke="currentColor"
    />
  </svg>
`, i = o`
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.7274 21.9997H18.2728C19.7791 21.9997 21 20.7788 21 19.2724V16.5452"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.36367 14C7.36367 12.8954 6.46824 12 5.36367 12H2.81824V16.5454C2.81824 17.55 3.63187 18.3636 4.63641 18.3636H5.36367C6.46824 18.3636 7.36367 17.4682 7.36367 16.3636V14Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21 12H18.4545C17.35 12 16.4545 12.8954 16.4545 14V16.3636C16.4545 17.4682 17.35 18.3636 18.4545 18.3636H19.1818C20.1863 18.3636 21 17.55 21 16.5454V12Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21 11.9999V11.0909C21 6.06998 16.93 2 11.9091 2C6.88821 2 2.81824 6.06998 2.81824 11.0909V11.9999"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle
      cx="0.75"
      cy="0.75"
      r="0.75"
      transform="matrix(1 0 0 -1 13 22.75)"
      stroke="currentColor"
    />
  </svg>
`, n = o`
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.59851 9.24246C1.59851 4.64418 5.32595 0.916748 9.92423 0.916748C14.5225 0.916748 18.2499 4.64418 18.2499 9.24246L18.25 16.0605C18.25 17.73 16.8968 19.0832 15.2273 19.0832H12.2969C12.0909 19.3134 11.7915 19.4583 11.4583 19.4583C10.837 19.4583 10.3333 18.9546 10.3333 18.3333C10.3333 17.7119 10.837 17.2083 11.4583 17.2083C11.7915 17.2083 12.0908 17.3531 12.2968 17.5832H15.2273C16.0684 17.5832 16.75 16.9016 16.75 16.0605V15.9206C16.511 16.0063 16.2533 16.053 15.9848 16.053H15.7121C14.1933 16.053 12.9621 14.8218 12.9621 13.303V12C12.9621 10.4813 14.1933 9.25004 15.7121 9.25004H16.7499V9.24246C16.7499 5.47262 13.6941 2.41675 9.92423 2.41675C6.15437 2.41675 3.09851 5.47261 3.09851 9.24246V9.25004H4.13637C5.65515 9.25004 6.88637 10.4813 6.88637 12V13.303C6.88637 14.8218 5.65515 16.053 4.13637 16.053H3.86365C2.61232 16.053 1.59851 15.0392 1.59851 13.7879V9.24246Z"
      fill="currentColor"
    />
  </svg>
`, l = o`
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.27881 7.39397C1.27881 3.71535 4.26076 0.733398 7.93938 0.733398C11.618 0.733398 14.6 3.71535 14.6 7.39397V8.00003L14.5999 8.00703V11.0154L14.6001 11.0302V12.8483C14.6001 14.184 13.5175 15.2665 12.1819 15.2665H9.83767C9.67287 15.4507 9.43334 15.5667 9.16672 15.5667C8.66967 15.5667 8.26672 15.1637 8.26672 14.6667C8.26672 14.1696 8.66967 13.7667 9.16672 13.7667C9.43321 13.7667 9.67265 13.8825 9.83744 14.0665H12.1819C12.8548 14.0665 13.4001 13.5212 13.4001 12.8483V12.7363C13.2088 12.8049 13.0027 12.8423 12.7878 12.8423H12.5696C11.3546 12.8423 10.3696 11.8573 10.3696 10.6423V9.5999C10.3696 8.38488 11.3546 7.3999 12.5696 7.3999H13.4V7.39397C13.4 4.37809 10.9553 1.9334 7.93938 1.9334C4.9235 1.9334 2.47881 4.37809 2.47881 7.39397V7.3999H3.30909C4.52412 7.3999 5.50909 8.38488 5.50909 9.5999V10.6423C5.50909 11.8573 4.52412 12.8423 3.3091 12.8423H3.09092C2.08986 12.8423 1.27881 12.0313 1.27881 11.0302V7.39397Z"
      fill="currentColor"
    />
  </svg>
`, C = o`
  ${t((r) => r._type === "outline", i)}
  ${t((r) => r._type === "solid", e)}
  ${t((r) => r._type === "mini", n)}
  ${t((r) => r._type === "micro", l)}
`;
export {
  C as headsetTemplate
};
